import { ReactComponent as ArrowBack } from '../../../assets/arrow-back-icon.svg';
import { Button } from './back-button.styles';

const BackButton = ({ onClick }: { onClick: () => void }) => {
    return (
        <Button onClick={onClick} variant="outlined" color="primary">
            <ArrowBack height={30} />
        </Button>
    );
};

export default BackButton;
